const Characteristic = ({characteristic}) => {
    
  return (
    <p className="characteristic">{characteristic}</p>
  )
}

export default Characteristic